<script setup lang="ts">
    import { nextTick, ref, watch } from 'vue';
    import { __ } from '../../stores/expressions';
    import { useFilterStoreByName } from '@/js/stores/filter';
    import { FilterStoreName } from '@/js/services/api/filter/types';

    const props = defineProps<{
        filterStoreName: FilterStoreName;
    }>();

    const filter = useFilterStoreByName(props.filterStoreName);

    const resolved = ref<boolean>(false);
    const unresolved = ref<boolean>(false);

    watch(
        () => filter.all?.onlyResolved,
        (newOnlyResolved) => {
            nextTick(() => {
                if (newOnlyResolved === true) {
                    resolved.value = true;
                    unresolved.value = false;
                } else if (newOnlyResolved === false) {
                    resolved.value = false;
                    unresolved.value = true;
                } else if (filter.onlyResolvedBothCheckedAsNull) {
                    resolved.value = true;
                    unresolved.value = true;
                } else {
                    resolved.value = false;
                    unresolved.value = false;
                }
            });
        },
        {
            immediate: true,
        }
    );

    function toggle(type: 'resolved' | 'unresolved') {
        if (!filter.all) return;

        if (type === 'resolved') {
            resolved.value = !resolved.value;
        } else {
            unresolved.value = !unresolved.value;
        }

        filter.onlyResolvedBothCheckedAsNull = false;

        if (resolved.value && !unresolved.value) {
            filter.all.onlyResolved = true;
        } else if (!resolved.value && unresolved.value) {
            filter.all.onlyResolved = false;
        } else {
            filter.onlyResolvedBothCheckedAsNull = resolved.value || unresolved.value;
            filter.all.onlyResolved = null;
        }
    }
</script>

<template>
    <ul class="px-4 pb-5">
        <li class="relative">
            <label class="flex items-start py-1 text-body">
                <input
                    :checked="resolved"
                    data-name="resolved-checkbox"
                    type="checkbox"
                    class="Custom-checkbox"
                    @change="toggle('resolved')"
                />
                {{ __('yes') }}
            </label>
        </li>
        <li class="relative">
            <label class="flex items-start py-1 text-body">
                <input
                    :checked="unresolved"
                    data-name="unresolved-checkbox"
                    type="checkbox"
                    class="Custom-checkbox"
                    @change="toggle('unresolved')"
                />
                {{ __('no') }}
            </label>
        </li>
    </ul>
</template>
